import { css, cx } from '@emotion/css'
import { theme } from '../styles/theme.js'
import { Header } from './Header.jsx'
import { BottomNav } from './BottomNav.jsx'

const styles = {
  shell: css({
    minHeight: '100vh',
    paddingTop: '56px',
    paddingBottom: '64px',
    '@media (min-width: 768px)': {
      paddingBottom: '0',
      paddingLeft: '240px',
    },
  }),
  main: css({
    maxWidth: '720px',
    margin: '0 auto',
    padding: theme.spacing.lg,
    '@media (min-width: 768px)': {
      padding: theme.spacing.xl,
    },
  }),
  sidebar: css({
    display: 'none',
    '@media (min-width: 768px)': {
      display: 'flex',
      position: 'fixed',
      top: '56px',
      left: 0,
      bottom: 0,
      width: '240px',
      backgroundColor: theme.colors.surface,
      borderRight: `1px solid ${theme.colors.border}`,
      flexDirection: 'column',
      padding: theme.spacing.lg,
    },
  }),
  navLink: css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.md,
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    borderRadius: theme.radii.md,
    color: theme.colors.textMuted,
    fontSize: theme.typography.fontSize.base,
    fontWeight: 500,
    marginBottom: theme.spacing.xs,
    transition: 'all 0.1s ease',
    '&:hover': {
      backgroundColor: theme.colors.surfaceElevated,
      color: theme.colors.text,
    },
    '&.active': {
      backgroundColor: theme.colors.surfaceElevated,
      color: theme.colors.primary,
    },
  }),
}

const AppShell = ({ children }) => {
  return (
    <>
      <Header />

      <div className={styles.sidebar}>
        <a href="/" className={styles.navLink}>Home</a>
        <a href="/explore" className={styles.navLink}>Explore</a>
        <a href="/profile" className={styles.navLink}>Profile</a>
      </div>

      <div className={styles.shell}>
        <main className={styles.main}>
          {children}
        </main>
      </div>

      <BottomNav />
    </>
  )
}

export { AppShell }
